export default __webpack_public_path__ + "52f3b6c8744cbb179d236f49bbc1f960.svg";